import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class PublicAccessInterceptor implements HttpInterceptor {


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    const url = new URL(window.location.href);
    const acronym = url.pathname.split('/').pop();

    const authRequest = token && acronym
      ? request.clone({
        headers: request.headers.set('clin-token', token).set('acronym', decodeURI(acronym)),
      })
      : request;

    return next.handle(authRequest);
  }

}
